export default "__VITE_ASSET__0f6293bc__"